function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.063 0c-.328 0-.648.126-.9.37L9.38 2.156l4.458 4.471 1.784-1.768c.504-.514.504-1.314 0-1.802L12.955.37a1.283 1.283 0 00-.892-.37zm-3.28 2.753l-6.814 6.83 2.153.236.152 1.928 1.917.143.244 2.156 6.814-6.83-4.467-4.463zm-7.31 7.613L0 16l5.636-1.508-.202-1.819-1.943-.143-.151-1.953",
  fill: "#9A99A2"
});

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref);
}

export default SvgEdit;